<template>
  <div>
    <Navbar></Navbar>
    <main>
      <FullLoader :loading="loading"/>
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center page-header">
            <a class="header-action" @click="goToDashboard()">
              <img class="header-action back" src="@/assets/images/x.svg">
            </a>
            <h1>
              <span class="underline h1style" @click="goToDashboard()">{{this.eventDetail.name}}</span>
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span class="underline" @click="goToDashboard()">Prizes</span>
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span>{{arg.prizeName}}</span>
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span>Audit History</span>
            </h1>
          </div>

          <div class="col-12 history-table">
            <div v-for="(item,index) in auditHistory" v-if="auditHistory.length > 0">
              <div class="history-date">
                {{ item.historyDate }}
                <em>( All times are displayed in {{ (new Date()).toTimeString().split(' ')[1] }} )</em>
              </div>
              <div
                class="history-row"
                v-for="history in item.historyList"
                v-bind:class="{ hideBorder: history.sameTimeOnNext }"
              >
                <time>{{ history.time }}</time>
                <span class="user" v-bind:class="{ confirmed: history.isConfirmed }">
                  <span>{{ history.name }}</span>
                  <span class="email">({{ history.email }})</span>
                </span>
                <span v-html="history.message"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import FullLoader from "@/components/FullLoader";
import axios from "axios";

export default {
  name: "AuditHistory",
  data() {
    return {
      auditHistory: [],
      eventDetail: { name: "" },
      arg: { prizeName: "" },
      loading: true
    };
  },
  computed: {
    gevmeLink() {
      return `https://dev.gevme.com/${localStorage.getItem(
        "org_id"
      )}/events/${localStorage.getItem("event_id")}`;
    }
  },
  components: {
    FullLoader,
    Navbar
  },
  methods: {
    goToDashboard() {
      this.$router.push({
        name: "Dashboard"
      });
    }
  },
  mounted() {
    document.getElementsByTagName(
      "title"
    )[0].innerText = `Audit History • GEVME Lucky Draw`;
    this.arg = this.$route.query;
    this.eventDetail.name = localStorage.getItem("event_name");

    var day = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];
    var month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    var removedOnes = ({ before, after }) => {
      let [beforeIds, afterIds] = [before, after].map(i =>
        i.lists.map(o => o.id)
      );
      return [...before.lists, ...after.lists].filter(o =>
        new Set(
          [...new Set([...beforeIds, ...afterIds])].filter(
            id => !new Set(afterIds).has(id)
          )
        ).has(o.id)
      );
    };

    axios
      .post(
        ENDPOINT,
        {
          query: `
          {
            auditLogs(
              where: {
                prize: {
                  id: "${this.arg.prizeid}"
                }
              })
              {data logType createdAt author { gevmeUser } }
          }`
        },
        {
          headers: {
            Authorization: localStorage.getItem("gevme_token")
          }
        }
      )
      .then(response => {
        this.loading = false;
        var dataList = response.data.data.auditLogs;

        var dateGroup = [];
        var newData = [];

        var getTime = currentDate => {
          //, previousDate, isNextHistory

          let hr = currentDate.getHours(),
            mi = currentDate.getMinutes();
          /*var isSameTime;
              if(previousDate){
                previousDate = new Date(previousDate.createdAt);
                isSameTime = previousDate.getHours() === hr && previousDate.getMinutes() === mi;
              }
              if(isNextHistory){
                return isSameTime;
              }*/
          mi = mi === 0 ? "00" : ("0" + mi).slice(-2);
          return hr + ":" + mi;
          //return previousDate && isSameTime ? '' : (hr +':'+ mi);
        };

        var getMessage = history => {
          let message = {
            cancelDraw: '<span class="text-danger">cancelled</span> the draw',
            confirmDraw: '<span class="text-success">confirmed</span> the draw',
            createPrize: '<span class="text-success">created</span> the prize',
            deletePrize: "deleted the prize"
          };
          if (history.logType === "updateDraw") {
            let status = history.data.draw.status;
            var fullName = "",
              position = "";
            if (["accept", "respin", "skip", "move"].indexOf(status) >= 0) {
              let attendee = history.data.lastDraw.selectedAttendee;
              fullName = `${attendee.firstname} ${attendee.lastname}`;
              position = history.data.lastDraw.position;
            }
            if (status === "accept") {
              return `<span class="text-success">confirmed</span> ${fullName} as <strong>Winner ${position}</strong>`;
            }
            if (status === "respin") {
              return `rejected ${fullName} as <strong>Winner ${position}</strong> and respun with reason <strong>"${
                history.data.draw.reason
              }"</strong>`;
            }
            if (status === "move") {
              return `rejected <strong>${fullName}</strong> as <strong>Winner ${position}</strong> and moved to the next winner with reason <strong>"${
                history.data.draw.reason
              }"</strong>`;
            }
            if (status === "skip") {
              return `skipped for <strong>Winner ${
                history.data.draw.position
              }</strong>`;
            }
            if (status === "cancel") {
              return '<span class="text-danger">cancelled</span> the draw';
            }
            if (status === "start") {
              return '<span class="text-success">started</span> the draw';
            }
          } else if (history.logType === "createDraw") {
            return `was drawn as <strong>Winner ${
              history.data.position
            }</strong>`;
          } else {
            return message[history.logType];
          }
        };

        dataList.forEach((history, index, array) => {
          //create date from response date.
          let dateObject = new Date(history.createdAt);
          let date =
            day[dateObject.getDay()] +
            ", " +
            dateObject.getDate() +
            " " +
            month[dateObject.getMonth()] +
            " " +
            dateObject.getFullYear();

          let dateIndex = dateGroup.indexOf(date);
          if (dateIndex === -1) {
            dateGroup.push(date);
            newData.push({
              historyDate: date,
              historyList: []
            });
          }

          let gevmeUser = history.author.gevmeUser;

          if (history.logType === "createPrize") {
            let fullName = `${gevmeUser.firstname} ${gevmeUser.lastname}`;
            newData[dateGroup.indexOf(date)].historyList.push({
              time: getTime(dateObject), //array[index-1], false
              name: fullName,
              email: gevmeUser.email,
              message: getMessage(history),
              sameTimeOnNext: true,
              isConfirmed: false,
              email: gevmeUser.email
            });
            let newLI = history.data.lists
              .map(a => {
                return a.name;
              })
              .join(", ");
            let additionalMessages = [
              `set the prize name to <strong>${history.data.name}</strong>`,
              `set the number of <strong>Winners</strong> to <strong>${
                history.data.winnerCount
              }</strong>`,
              `set the list(s) of attendees to <strong>${newLI}</strong>`
            ];
            for (let i = 0; i <= 2; i++) {
              newData[dateGroup.indexOf(date)].historyList.push({
                time: "",
                name: fullName,
                message: additionalMessages[i],
                sameTimeOnNext: i !== 2,
                isConfirmed: false,
                email: gevmeUser.email
              });
            }
          } else if (history.logType === "updatePrize") {
            let { before, after } = history.data;
            let edits = [];
            if (before.name !== after.name) {
              edits.push(
                `edited the Prize Name from <strong>${
                  before.name
                }</strong> to <strong>${after.name}</strong>`
              );
            }
            if (before.winnerCount !== after.winnerCount) {
              edits.push(
                `edited the number of <strong>Winners</strong> from <strong>${
                  before.winnerCount
                }</strong> to <strong>${after.winnerCount}</strong>`
              );
            }

            let addedItems = removedOnes({ before: after, after: before });
            let removedItems = removedOnes({ before, after });

            let isAdded = addedItems.length > 0;
            let isRemoved = removedItems.length > 0;

            if (isAdded) {
              let added = addedItems.map(a => a.name).join(", ");
              edits.push(`added the list(s) <strong>${added}</strong>`);
            }
            if (isRemoved) {
              let removed = removedItems.map(a => a.name).join(", ");
              edits.push(`removed the list(s) <strong>${removed}</strong>`);
            }
            if (isAdded || isRemoved) {
              let updated = after.lists.map(a => a.name).join(", ");
              edits.push(
                `set the list(s) of attendees to <strong>${updated}</strong>`
              );
            }

            edits.map((edit, i) => {
              newData[dateGroup.indexOf(date)].historyList.push({
                time: getTime(dateObject), //i === 0 ? getTime(array[index-1], dateObject, false): '',
                name: `${gevmeUser.firstname} ${gevmeUser.lastname}`,
                message: edit,
                sameTimeOnNext: i !== edits.length - 1,
                isConfirmed: false,
                email: gevmeUser.email
              });
            });
          } else if (history.logType === "createDraw") {
            let attendee = history.data.selectedAttendee;
            let time = getTime(dateObject); //array[index-1], false

            newData[dateGroup.indexOf(date)].historyList.push({
              time: time,
              name: `${attendee.firstname} ${attendee.lastname}`,
              message: getMessage(history),
              sameTimeOnNext: false,
              isConfirmed: true,
              email: attendee.ticket_no
            });

            newData[dateGroup.indexOf(date)].historyList.push({
              time: time,
              name: `${gevmeUser.firstname} ${gevmeUser.lastname}`,
              message: `spun for <strong>Winner ${
                history.data.position
              }</strong>`,
              //sameTimeOnNext: getTime(array[index+1], dateObject, true) === true,
              isConfirmed: false,
              email: gevmeUser.email
            });
          } else {
            newData[dateGroup.indexOf(date)].historyList.push({
              time: getTime(dateObject), //array[index-1], dateObject, false
              name: `${gevmeUser.firstname} ${gevmeUser.lastname}`,
              message: getMessage(history),
              sameTimeOnNext: false,
              isConfirmed: false,
              email: gevmeUser.email
            });
          }
        });
        this.auditHistory = newData;
      });
  }
};
</script>

<style scoped>
main {
  padding-bottom: 75px;
}
.underline {
  text-decoration: underline;
  cursor: pointer;
}

@media screen and (max-width: 610px) {
  .page-header a.header-action {
    left: 7px;
  }

  .page-header {
    padding-left: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AuditHistory.vue